export type ExportKind = "all" | "problem" | "solution";
export type ExportFormat = "csv" | "tsv";
export type ExportOrderField =
  | "dateCreated"
  | "dateModified"
  | "case_id"
  | "title"
  | "total_cards"
  | "attrs_with_cards";

export type ExportSettings = {
  kind: ExportKind;
  orderField: ExportOrderField;
  descending: boolean;
  format: ExportFormat;
  descLen: number;
  attrs: boolean;
  spheres: boolean;
  limit: number;
};

export const MAX_LIMIT = 10000;
// Полная длина описания: тот же предел, что у редактора при создании
// проблемы/решения (card-content-validation.ts) — в самом поле лимита нет.
export const MAX_DESC_LEN = 5000;

export const DEFAULT_SETTINGS: ExportSettings = {
  kind: "all",
  orderField: "dateCreated",
  descending: true,
  format: "csv",
  descLen: MAX_DESC_LEN,
  attrs: true,
  spheres: true,
  limit: MAX_LIMIT,
};

export const ORDER_FIELD_LABELS: Record<ExportOrderField, string> = {
  dateCreated: "Дата создания",
  dateModified: "Дата изменения",
  case_id: "ID проблемы",
  title: "Название",
  total_cards: "Число карточек",
  attrs_with_cards: "Число атрибутов с карточками",
};

// Query-параметры эндпоинта выгрузки (offset не передаём — пагинации в форме нет).
export const buildExportQuery = (settings: ExportSettings): string => {
  const params = new URLSearchParams({
    kind: settings.kind,
    ordering: `${settings.descending ? "-" : ""}${settings.orderField}`,
    sep: settings.format,
    desc_len: String(settings.descLen),
    attrs: settings.attrs ? "1" : "0",
    spheres: settings.spheres ? "1" : "0",
    limit: String(settings.limit),
  });

  return params.toString();
};

// Имя файла строим на клиенте, чтобы не зависеть от Content-Disposition
// (он не доступен для чтения при кросс-доменном запросе без CORS_EXPOSE_HEADERS).
export const exportFileName = (format: ExportFormat, now = new Date()) =>
  `cases-${now.toISOString().slice(0, 10)}.${format}`;
